import type { Lang } from '@/types';

import * as frContent from './fr';
import * as enContent from './en';

import { useLang } from '@/i18n';

/**
 * Forme d'un jeu de contenu, definie par le francais.
 *
 * Le type de retour de `content()` force `./en` a exposer exactement les memes
 * noms avec les memes types : un fichier anglais oublie fait echouer le
 * typecheck. Le compilateur ne peut en revanche pas exiger le meme NOMBRE de
 * cartes ni les memes slugs — `scripts/verify-seo.mjs` s'en charge au build.
 */
export type SiteContent = typeof frContent;

export function content(lang: Lang): SiteContent {
  return lang === 'en' ? enContent : frContent;
}

/** Contenu de la langue de la route courante. */
export function useContent(): SiteContent {
  return content(useLang());
}
